import { fetch } from '@/shared/fetch';

export const assignConsultation = async (
    consultationUID: string,
): Promise<boolean> => {
    return await fetch(
        '/api/consultations/' + consultationUID + '/assign-self',
        'POST',
    );
};
